<template>
    <div id="wrapper" :class="{'sidebar-toggled':showNavigation,'dark':darkTheme}">
      <Header 
        @showHideNav="showHideNavHandler" 
        :showNavigation="showNavigation" 
        @changeTheme="darkTheme = !darkTheme"
        :darkTheme="darkTheme" /> 
      <main>
          <Navigation/>
          <section class="page-content">
              <router-view :darkTheme="darkTheme"></router-view>
          </section>
      </main>
      <notifications position="bottom right" />
    </div>
</template>

<script>
import Navigation from './common/Navigation'
import Header from './common/Header'
export default {
  name: 'innerPage',
  components: {
    Navigation,
    Header
  },
  data: () => ({
    showNavigation: false,
    darkTheme: localStorage.getItem('darkTheme') === 'true' || false
  }),
  watch:{
    darkTheme: function(){
      localStorage.setItem('darkTheme',this.darkTheme);
    }
  },
  methods:{
    showHideNavHandler(){
      this.showNavigation = !this.showNavigation;
      // for charts (0 for next vue tick)
      setTimeout(function(){
        window.dispatchEvent(new Event('resize'));
      },0);
    }
  }
};
</script>
<style lang="scss">
#wrapper{
  .page-content{
    // transition: .3s ease;
    padding: 83px 24px 10px;
    width: 100%;
      @media (max-width: 400px) {
        padding: 83px 14px 10px;
      }
    & > *{
        max-width: 1290px;
        margin: auto;
        }
    }
    &.sidebar-toggled{
      .main-sidebar{
          transform: translateX(0px);
      }
      .page-content {
        transform: translateX(229px);
        @media (min-width: 1400px) {
          width: calc(100% - 229px);
        }
      }
  }
}
</style>